import { KestrelViewerMessageCallbackAPI } from 'features/kestrelViewer/types/KestrelViewerInterfaces'
import { KVMeasurement, KVMeasurementJSON, RolodexEntryPatchJson } from 'types'

import { KVMessageDef } from './index'

export function getNewMeasurementMessage() {
  return {
    type: 'newMeasurement',
    requiredData: ['measurementId'],

    callback: (
      json: KVMeasurementJSON,
      kv: KestrelViewerMessageCallbackAPI
    ) => {
      const measurement = KVMeasurement.fromJSON(json)
      // Set default label if none provided
      if (!measurement.label) {
        measurement.label = `Measurement`
      }

      // Ignore if measurement has no segments
      if (!measurement.segments || measurement.segments.length === 0) {
        return
      }

      if (kv.measurements) {
        let newKVMeasurements = [...kv.measurements]
        // If there is already a measurement with the same id, update the measurement
        if (kv.measurements?.find((m) => m.id === measurement.id)) {
          const index = kv.measurements?.findIndex(
            (m) => m.id === measurement.id
          )
          if (index !== undefined) {
            newKVMeasurements[index] = measurement
          }
        } else {
          newKVMeasurements = [...kv.measurements, measurement]
        }
        kv.setMeasurements(newKVMeasurements)

        const patchData: RolodexEntryPatchJson = {
          id: kv.kestrelModel?.id ?? '',
          data: {
            measurements:
              newKVMeasurements?.map((m) => KVMeasurement.toJSON(m)) ?? [],
          },
        }
        kv.rolodexPatch([patchData])
      }
    },
  } as KVMessageDef
}
